












import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSpinningProgress } from '@libs-uuif/shared/sw-progress';

const cssPrefix = 'sw-widget-loading';

@Component({
  components: {
    SwSpinningProgress,
  },
})

export default class SwWidgetLoading extends SwExtendedVue {
  cssPrefix = cssPrefix;
}
